import React from 'react';
import { Box } from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ApprovalOutlinedIcon from '@mui/icons-material/ApprovalOutlined';
import BookmarkAddedOutlinedIcon from '@mui/icons-material/BookmarkAddedOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';

const CmpProjectStatusIcon = ({ project }) => {
  if (!project || !project?.cmpGrade || project?.cmpGrade === 0) {
    return null;
  }

  switch (project?.cmpGrade) {
    case '1':
      return (
        <Box
          sx={{
            mx: 1,
            color: '#fff',
            bgcolor: 'success.main',
            borderRadius: 1,
            p: 0.3,
          }}
        >
          <AutoAwesomeOutlinedIcon />
        </Box>
      );

    case '2':
      return (
        <Box
          sx={{
            mx: 1,
            color: '#fff',
            bgcolor: 'error.main',
            borderRadius: 1,
            p: 0.3,
          }}
        >
          <FeedOutlinedIcon />
        </Box>
      );

    case '3':
      return (
        <Box
          sx={{
            mx: 1,
            color: '#fff',
            bgcolor: 'info.main',
            borderRadius: 1,
            p: 0.3,
          }}
        >
          <BookmarkAddedOutlinedIcon />
        </Box>
      );

    case '4':
      return (
        <Box
          sx={{
            mx: 1,
            color: '#fff',
            bgcolor: 'secondary.main',
            borderRadius: 1,
            p: 0.3,
          }}
        >
          <ApprovalOutlinedIcon />
        </Box>
      );

    case '5':
      return (
        <Box
          sx={{
            mx: 1,
            color: '#fff',
            bgcolor: 'text.disabled',
            borderRadius: 1,
            p: 0.3,
          }}
        >
          <ApprovalOutlinedIcon />
        </Box>
      );
    default:
      return <div></div>;
  }
};

export default CmpProjectStatusIcon;
